import { parseHtmlString } from "@/utils/helpers/html";
import { Heading, Paragraph } from "@/components/ui/Typography"
import { WebsitePageSection } from "@/types"
import EditableSection from "@/components/admin/Content/WebPages/EditableSection";

const KeyHighlightsHeader = ({ data }: { data: WebsitePageSection }) => {
    return (
        <EditableSection
            sectionTag={data.sectionTag}
            contentType={data.contentType}
            data={data}
        >
            <div className="flex flex-col gap-2">
                <Paragraph className="bg-gray-50 rounded-2xl px-3 py-1 !text-sm flex items-center justify-center text-forestGreen-100 w-fit">
                    Key Highlights
                </Paragraph>
                <div className="flex items-center gap-6">
                    <Heading level={4}>{data.sectionTitle ?? "Through the Lens of AFSA"}</Heading>
                </div>
                <Paragraph dangerouslySetInnerHTML={parseHtmlString(data.description ?? "Featured video and image highlights from AFSA")} />
            </div>
        </EditableSection>
    )
}

export default KeyHighlightsHeader
